// src/components/Routes/UserBlocking.tsx
import React from 'react';
import { DefaultButton, Stack, Icon } from '@fluentui/react';

interface UserBlockingProps {
  user: {
    id: string;
    username: string;
    email: string;
    isBlocked: boolean;
    role: string;
  };
  currentUserRole: string;
  refetchUsers: () => void;
  blockUser: (email: string) => Promise<any>;
  unblockUser: (email: string) => Promise<any>;
  asMenuItem?: boolean;
  onActionComplete?: () => void; // ✅ Новый проп для закрытия меню
}

const UserBlocking: React.FC<UserBlockingProps> = ({
  user,
  currentUserRole,
  refetchUsers,
  blockUser,
  unblockUser,
  asMenuItem = false,
  onActionComplete
}) => {
  const canBlock = ['admin', 'superadmin'].includes(currentUserRole) && user.role === 'user' && !user.isBlocked;
  const canUnblock = ['admin', 'superadmin'].includes(currentUserRole) && user.isBlocked;

  if (!canBlock && !canUnblock) return null;

  const handleAction = async () => {
    try {
      if (canBlock) {
        await blockUser(user.email);
      } else {
        await unblockUser(user.email);
      }
      
      // ✅ Закрываем меню после успешного действия
      if (onActionComplete) {
        onActionComplete();
      }
    } catch (error) {
      console.error('Ошибка изменения статуса блокировки:', error);
    }
  };

  if (asMenuItem) {
    return (
      <div 
        onClick={handleAction}
        style={{
          width: '100%',
          padding: '8px 8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          color: canUnblock ? '#107c10' : '#a4262c',
          fontSize: '14px',
          fontFamily: 'Segoe UI, sans-serif'
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f3f2f1')}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
      >
        <Icon
          iconName={canUnblock ? 'Unlock' : 'BlockContact'}
          styles={{ 
            root: { 
              marginRight: 8, 
              color: canUnblock ? '#107c10' : '#a4262c',
              fontSize: 16 
            } 
          }}
        />
        <span style={{ color: canUnblock ? '#107c10' : '#a4262c' }}>
          {canUnblock ? 'Разблокировать' : 'Заблокировать'}
        </span>
      </div>
    );
  }

  return (
    <Stack horizontal tokens={{ childrenGap: 8 }}>
      <DefaultButton
        onClick={handleAction}
        styles={{ 
          root: { 
            height: 26,
            color: canUnblock ? '#107c10' : '#a4262c'
          } 
        }}
      >
        {canBlock ? 'Блокировать' : 'Разблокировать'}
      </DefaultButton>
    </Stack>
  );
};

export default UserBlocking;